type Urgency = 'normal' | 'urgent' | 'critique';

export default function UrgencyBadge({ level }: { level: Urgency }) {
  return <span className={`badge badge-${level}`}>{level}</span>;
}

export function formatDeadline(d: string | null | undefined): string {
  if (!d) return '—';
  const date = new Date(d);
  const today = new Date();
  const diff = Math.round((date.getTime() - today.getTime()) / 86_400_000);
  if (diff < 0) return `en retard de ${-diff}j`;
  if (diff === 0) return "aujourd'hui";
  if (diff === 1) return 'demain';
  return `dans ${diff}j`;
}
